import { Component, ViewChild } from '@angular/core';
import { VerTiposProductoComponent } from '../../../../forms/productos/tipos-producto/ver-tipos-producto/ver-tipos-producto.component';
import { ProductoService } from '../../../../providers/producto.service';

@Component({
  selector: 'app-tipos-producto',
  templateUrl: './tipos-producto.component.html',
  styleUrls: ['./tipos-producto.component.scss']
})
export class TiposProductoComponent {
  @ViewChild('verTiposProducto') verTiposProducto: VerTiposProductoComponent;
  public tipoOferta: string;

  constructor(
    private ProductoService: ProductoService
  ) { }

  ngOnInit() {
    this.tipoOferta = this.ProductoService.getTipoOferta();
  }

  actualizarTabla(): void {
    this.verTiposProducto.actualizarTabla();
  }
}

